// 使用浏览器构建，兼容项目现有的 Webpack 4。
const MarkdownIt: typeof import('markdown-it') = require('markdown-it/dist/markdown-it')

// 消息正文只解析 Markdown，不执行服务端正文中的 HTML。
const markdown = new MarkdownIt({ html: false, breaks: true, linkify: true })

markdown.renderer.rules.link_open = (tokens, index, options, env, self) => {
  tokens[index].attrSet('target', '_blank')
  tokens[index].attrSet('rel', 'noopener noreferrer')
  return self.renderToken(tokens, index, options)
}

export function renderAiShareMarkdown(content: string) {
  return markdown.render(content)
}

export function publicResourceUrl(url: string | null) {
  if (!url) return undefined
  try {
    const parsed = new URL(url)
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : undefined
  } catch {
    return undefined
  }
}
